import React from "react";
import { RCCButton, RCCColorPicker, RCCGrid, RCCHTMLTextEditor, RCCIcon, RCCInput, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import returnColor from "src/utils/returnColor";
import { v4 } from "uuid";
import { IComponentQuadrants } from "./interface";

const Quadrants: React.FC<IComponentQuadrants> = ({
	setValue,
	source,
	register,
	control,
	errors,
	clearErrors,
	prepend,
	remove
}) => {

	const { translate} = useTranslation();
	const defaultColors = ["#96281B", "#D35400", "#F5AB35", "#3A539B", "#52B3D9", "#019875", "#36D7B7", "#6C7A89", "#D5DADC"];

	const addQuadrant = () => {
		clearErrors("catba002");
		const newQuadrant = {...source[source.length-1]};
		newQuadrant.id = v4();
		newQuadrant.caa002Id = 0;
		newQuadrant.caa002Codigo = "";
		newQuadrant.caa002Descricao = "";
		newQuadrant.caa002Cor=defaultColors[source.length + 1 > defaultColors.length ? defaultColors.length - 1 : source.length];
		newQuadrant.caa002Explicacao = "";
		newQuadrant.collapseExplanation= false;
	    newQuadrant.disabledCode= false;
		prepend(newQuadrant);
	};

	const deleteQuadrant = (index:number) => {
		remove(index);
	};

	const toggleExplanation = (index: number) => {
		setValue(`catba002.${index}.collapseExplanation`, !source[index].collapseExplanation);
	};

	return(
		<RCCGrid container>
			<RCCGrid container justify="space-between" alignContent="flex-end" wrap="nowrap">
				{errors.catba002?.message &&
					<RCCGrid container item style={{
						alignSelf:"center",
						color:"var(--red)"
					}}>	
						<RCCIcon name="errorOutline" className="alert-error-of-component-input" size={20} color="var(--red)"/>
						<span>{errors.catba002?.message}</span>
					</RCCGrid>
				}
				<RCCGrid container item justify="flex-end">
					<RCCTooltip
						text={translate("Adicionar Quadrante")}
						color="purple"
						position="left">
						<RCCButton
							icon={{name: "plus"}}
							color="purple"
							onClick={() => {addQuadrant();}}
							layout="isRounded"
							size="sm"
						/>	
					</RCCTooltip>
				</RCCGrid>
			</RCCGrid>
			<hr/>
			{source.map((item,index) => (
				<RCCGrid 
					key={item.id}
					container
					justify="space-between">
					<RCCGrid
						container
						item
						spacing={2}
						md={12}
						sm={12}
						alignContent="center"
					>
						<RCCGrid  container item lg={2} md={2} sm={4} xs={12}>
							<RCCInput 
								register={register}
								error={errors.catba002 && errors?.catba002[index]?.caa002Codigo}
								name={`catba002.${index}.caa002Codigo`}
								label={translate("Código")}
								maxLength={20}
								defaultValue={item.caa002Codigo}
								disabled={item.disabledCode}
								required
							/>
						</RCCGrid>
						<RCCGrid container item lg={6} md={4} sm={12} xs={12}>
							<RCCInput 
								register={register}
								error={errors.catba002 && errors?.catba002[index]?.caa002Descricao}
								name={`catba002.${index}.caa002Descricao`}
								label={translate("Descrição")}
								maxLength={60}
								defaultValue={item.caa002Descricao}
								required
							/>
						</RCCGrid>
						<RCCGrid 
							container
							item
							lg={1}
							md={2}
							sm={6}
							xs={6}
							alignContent="flex-end"
						>
							<RCCColorPicker
								name={`catba002.${index}.caa002Cor`}
								control={control}
								label={translate("Cor")}
								labelPosition="start"
								colorPickerProps ={{color:returnColor(item.caa002Cor)}}
								defaultValue={item.caa002Cor}
							/>
						</RCCGrid>
						<RCCGrid 
							container
							item
							lg={3}
							md={4}
							sm={6}
							xs={6}
							justify="flex-end"
							alignContent="flex-end">
							<RCCTooltip
								text={translate("Explicação")}
								color="grey"
								position="left">
								<RCCButton
									icon={{name: "comment"}}
									color="grey"
									onClick={() => {toggleExplanation(index);}}
									layout="isRounded"
									size="xs"
								/>	
							</RCCTooltip>
							<RCCTooltip
								text={translate("Excluir Quadrante")}
								color="red"
								position="left">
								<RCCButton
									icon={{name: "trash"}}
									color="red"
									onClick={() => {deleteQuadrant(index);}}
									layout="isRounded"
									size="xs"
								/>	
							</RCCTooltip>
						</RCCGrid>
					</RCCGrid>
					
					<RCCGrid container styleInline={`display: ${item.collapseExplanation ? "block !important" : "none !important"}`}>
						<RCCHTMLTextEditor 
							error={errors.catba002 && errors?.catba002[index]?.caa002Explicacao}
							name={`catba002.${index}.caa002Explicacao`}
							label={translate("Explicação")} 
							control={control} 
							defaultValue={item.caa002Explicacao}/>
					</RCCGrid>

				</RCCGrid>
			))}
		</RCCGrid>
	);
};

export default Quadrants;
